import { ChatScope, scopeKey } from '../scope';

/**
 * The single source of truth for transaction cache keys. Sub-resources hang
 * under `detail(txId)`, so invalidating `detail` cascades (prefix match) to
 * todos / documents / compliance / credit reports / vehicle, while a narrower
 * builder stays surgical.
 */
export const chatKeys = {
  messages: (s: ChatScope) => [...scopeKey.chat(s), 'messages'] as const,

  /**
   * Meta information about a chat - title, takeover status, etc
   *
   * @param s
   * @returns
   */
  meta: (s: ChatScope) => [...scopeKey.chat(s), 'meta'] as const
};
